module.exports = __webpack_public_path__ + "img/10002.226b492c.jpg";